import { Store } from 'react-notifications-component';
import CustomNoti from './customNotification';
import 'react-notifications-component/dist/theme.css'
import { ReactElement } from 'react';


const showMessage = (title: string, message: string, type: 'success' | 'danger' | 'info' | 'default' | 'warning') => {


    Store.addNotification({
        content: CustomNoti({ title: title, message: message, type: type }) as ReactElement,
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 5000,
        }
    });
}

export default showMessage;